import Config from '../definitions/Config';
import areFirstPartyCookiesEnabled from './areFirstPartyCookiesEnabled';
import fetchWithErrorHandling from './fetchWithErrorHandling';
import noticeError from './noticeError';


async function fetchWithStatusError(url, options) {
    if (url.startsWith(Config.API_GATEWAY_URL)) {
        options = options || {};
        options.headers = options.headers || {};
        options.headers['x-has-first-party-cookies'] = areFirstPartyCookiesEnabled();
    }

    try {
        // Using fetchWithErrorHandling here instead of fetchJSON
        //  because profile-faas may not return JSON
        const response = await fetchWithErrorHandling(url, options);

        return response;
    }
    catch (error) {
        const response = error.response;

        // If we have no response, bail and re-throw
        // Since we're not using fetchJSON we cannot rely on its noticeError
        if (!response) {
            noticeError(error, {
                message: '[fetchWithStatusError] Fetch failed',
                url,
                options,
            });

            throw error;
        }

        // Default to the code in the error's response
        let responseCode = error.response.status;
        let responseBody;

        try {
            // profile-faas sends the custom error code inside of response body
            responseBody = await response.json();
            responseCode = responseBody.code;
        } catch (_) {
            // it's okay, response body or code may not exist
        }

        const statusError = new FetchStatusError(response, responseCode);

        // Call noticeError with our new status error
        noticeError(statusError, {
            message: '[fetchWithStatusError] Fetch failed',
            url,
            options,

            responseStatusCode: responseCode,
            responseBody: responseBody,
        });

        throw statusError;
    }
}

class FetchStatusError extends Error {
    status;
    statusText;
    code;

    constructor(response, code) {
        super(`Fetch failed, ${response.status} ${response.statusText}`);
        this.status = response.status;
        this.statusText = response.statusText;
        this.code = code;
    }
}

export default fetchWithStatusError;
